import React from "react";
import { connect } from 'react-redux';
import Modal from 'react-bootstrap/Modal'
import { Button, FormGroup } from "shards-react";
import RangeDatePicker from "../common/RangeDatePicker";
import { getLinkEXCELInfoPrestador } from "../../core/helper";

class ExportInfoPrestadorModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            startDate: new Date(new Date().getFullYear(), '00', '01'),
            endDate: new Date(),
        }

        this.handleDate = this.handleDate.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handeDownloadExcel = this.handeDownloadExcel.bind(this);
    }

    handleDate({ date_start_value = "", date_end_value = "" }) {
        if (date_start_value)
            this.setState({
                startDate: date_start_value,
            });
        if (date_end_value)
            this.setState({
                endDate: date_end_value
            });
    }

    resetDate() {
        this.state = {
            startDate: new Date(new Date().getFullYear(), '00', '01'),
            endDate: new Date(),
        }
    }

    handleClose() {
        this.resetDate();
        this.props.handleClose();
    }

    handeDownloadExcel() {
        let url = getLinkEXCELInfoPrestador(this.state.startDate, this.state.endDate);
        window.open(url, '_blank');
        this.handleClose();
    }

    render() {
        const { show } = this.props
        const { startDate, endDate } = this.state

        return (
            <Modal
                dialogClassName="modal-md"
                show={show}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                style={{ zIndex: 2500 }}
                onHide={() => this.handleClose()}
            >
                <Modal.Header closeButton>
                    <h5 className="m-0">
                        Exportar
                    </h5>
                </Modal.Header>

                <Modal.Body>
                    <div className="d-flex align-items-center justify-content-center">
                        <FormGroup>
                            <RangeDatePicker handleDate={this.handleDate} startDate={startDate} endDate={endDate} showLabels />
                        </FormGroup>
                    </div>
                    <div className="text-right"> 
                        <Button onClick={() => this.handeDownloadExcel()} className="btn-sm mr-1">Exportar</Button>
                        <Button onClick={e => this.handleClose()} className="btn-sm">Cancelar</Button>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}

export default ExportInfoPrestadorModal;